// @flow

import get from 'lodash/get'

import { type DeviceType } from '@chatchamp/chatchamp-types'

import { DEFAULT_COLOR } from '../../common/defaultColor'

import { isQuickReplyMessage } from '../models/Message'
import { Channel } from '../../main/models'

import type { RootState } from './rootState'

export const getters = {
  isFromCustomer (state: RootState): Function {
    return (message) => message.from === state.customerId
  },
  googleAnalyticsId (state: RootState): string {
    return get(state.channel, ['googleAnalyticsId'])
  },
  privacyPolicy (state: RootState): string {
    return get(state.channel, ['privacyPolicy'], 'https://www.chatchamp.com/privacy/')
  },
  primaryColor (state: RootState): string {
    return get(state.channel, ['backgroundColor'], DEFAULT_COLOR)
  },
  customCss (state: RootState): string {
    return get(state.channel, ['customCss'], '')
  },
  headerTitle (state: RootState): string {
    return get(state.channel, ['headerTitle'], '')
  },
  avatarName (state: RootState): string {
    return get(state.channel, ['avatarName'], '')
  },
  productClickAction (state: RootState): string {
    return get(state.channel, ['productClickAction'], 'openUrl')
  },
  avatarImage (state: RootState, getters: any): string {
    return state.channel?.avatarImageUrl || ''
  },
  animatedAvatarImage (state: RootState, getters: any): string {
    return state.channel?.animatedAvatarImageUrl || getters.avatarImage
  },
  headerFont (state: RootState): string {
    return get(state.channel, ['headerFont'], '')
  },
  logoUrl (state: RootState): string {
    return get(state.channel, ['logoUrl'], '')
  },
  headerDescription (state: RootState): string {
    return get(state.channel, ['headerDescription'], '')
  },
  isChatInputEnabled (state: RootState, getters: any): boolean {
    const message = getters.latestMessageFromCustomer
    if (!message) return true

    return !(isQuickReplyMessage(message) && getters.latestMessage.id === getters.latestMessageFromCustomer.id)
  },
  device (state: RootState): DeviceType {
    return state.device
  },
  channel (state: RootState): Channel {
    return state.channel
  },
  chatbotPayload (state: RootState): string {
    return state.chatbotPayload
  },
  chatbotId (state: RootState, getters: any): ?number {
    return getters.latestMessage?.content.chatbotId
  },
  isEnabledABTest (state: RootState): boolean {
    return get(state.channel, 'isEnabledABTest', false)
  },
  wizardIntegrationId (state: RootState): ?string {
    return get(state.channel, ['wizardIntegrationId'], null)
  },
  isEnabledAddToCart (state: RootState): boolean {
    return get(state.channel, 'isEnabledAddToCart', false)
  }
}
